var map = {
	"./CriarEvento.vue": [
		"78f6",
		"chunk-fa7cee68"
	],
	"./Cronometro.vue": [
		"3af6",
		"chunk-b936d7ce"
	],
	"./CurrentFight.vue": [
		"f430",
		"chunk-78bfe2c7"
	],
	"./EditarEvento.vue": [
		"eaf0",
		"chunk-3d505a8e"
	],
	"./EventoDetalhe.vue": [
		"f183",
		"chunk-a481e198"
	],
	"./Eventos.vue": [
		"cc53",
		"chunk-0cda25c0"
	],
	"./Fights.vue": [
		"ef81",
		"chunk-769b91c8"
	],
	"./Groups.vue": [
		"3004",
		"chunk-1e17ea21"
	],
	"./Home.vue": [
		"4155",
		"chunk-ac11ebaa"
	],
	"./Inscricoes.vue": [
		"7f31",
		"chunk-2387ff1c"
	],
	"./InspectRobot.vue": [
		"630b",
		"chunk-df56168c"
	],
	"./Keys.vue": [
		"f049",
		"chunk-732ff0c9"
	],
	"./MinhaEquipe.vue": [
		"c361",
		"chunk-ed3cfc78"
	],
	"./Podio.vue": [
		"ffb6",
		"chunk-6fe08282",
		"chunk-7711d286"
	],
	"./Regras.vue": [
		"db9c",
		"chunk-1edb9d07"
	],
	"./Robots.vue": [
		"3732",
		"chunk-6fe08282",
		"chunk-6480977c"
	],
	"./Roleta.vue": [
		"d550",
		"chunk-30fafc54"
	],
	"./SignIn.vue": [
		"3f57",
		"chunk-d3fd6db2"
	],
	"./SignUp.vue": [
		"1e1f",
		"chunk-e9d0e7bc"
	],
	"./UserProfile.vue": [
		"94e2",
		"chunk-bec336b2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9665";
module.exports = webpackAsyncContext;